import React, { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { categoriesAPI } from '../../services/api'
import { Category } from '../../types'
import './Header.css'

const Header: React.FC = () => {
  const [categories, setCategories] = useState<Category[]>([])
  const [searchQuery, setSearchQuery] = useState('')
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const location = useLocation()

  useEffect(() => {
    loadCategories()
  }, [])

  const loadCategories = async () => {
    try {
      const response = await categoriesAPI.getAll()
      setCategories(response.categories)
    } catch (error) {
      console.error('Failed to load categories:', error)
    }
  }

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault()
    if (searchQuery.trim()) {
      window.location.href = `/search?q=${encodeURIComponent(searchQuery)}`
    }
  }

  const isLinkActive = (path: string) => {
    return location.pathname === path
  }

  const closeMenu = () => {
    setIsMenuOpen(false)
  }

  // Close menu when route changes
  useEffect(() => {
    closeMenu()
  }, [location.pathname])

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const nav = document.querySelector('.navigation')
      const target = event.target as Node
      if (nav && !nav.contains(target)) {
        closeMenu()
      }
    }

    if (isMenuOpen) {
      document.addEventListener('click', handleClickOutside)
    }

    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [isMenuOpen])

  return (
    <header className="header">
      <div className="header-top">
        <div className="container">
          <div className="header-info">
            <span className="date">{new Date().toLocaleDateString('vi-VN', {
              weekday: 'long',
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}</span>
          </div>
          <div className="header-search">
            <form onSubmit={handleSearch}>
              <input
                type="text"
                placeholder="Tìm kiếm..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <button type="submit">🔍</button>
            </form>
          </div>
        </div>
      </div>

      <div className="header-main">
        <div className="container">
          <div className="logo">
            <Link to="/">
              <h1>BÁO XÃ VIỆT TIẾN</h1>
              <p>Báo điện tử - Thông tin chính thức và đáng tin cậy</p>
            </Link>
          </div>
        </div>
      </div>

      <nav className="navigation">
        <div className="container">
          <div className="nav-wrapper">
            <button 
              className={`menu-toggle ${isMenuOpen ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label="Toggle navigation menu"
            >
              {isMenuOpen ? '✕' : '☰'}
            </button>
            
            <ul className={`nav-menu ${isMenuOpen ? 'open' : ''}`}>
              <li>
                <Link to="/" className={`nav-link ${isLinkActive('/') ? 'active home' : ''}`}>TRANG CHỦ</Link>
              </li>
              {categories.map((category) => (
                <li key={category.id}>
                  <Link 
                    to={`/category/${category.slug}`} 
                    className={`nav-link ${isLinkActive(`/category/${category.slug}`) ? 'active' : ''}`}
                  >
                    {category.name.toUpperCase()}
                  </Link>
                </li>
              ))}
              {/* <li>
                <Link to="/videos" className={`nav-link ${isLinkActive('/videos') ? 'active' : ''}`}>VIDEO</Link>
              </li>
              <li>
                <Link to="/podcasts" className={`nav-link ${isLinkActive('/podcasts') ? 'active' : ''}`}>PODCAST</Link>
              </li> */}
            </ul>
          </div>
        </div>
      </nav>
    </header>
  )
}

export default Header